import moment from "moment";
import "moment-timezone";

export const DEFAULT_TIME_ZONE = "America/Bogota";

export const FORMATS = {
    DATE_SHORT: "YYYY-MM-DD",
    DATE_LONG: "YYYY-MM-DD HH:mm:ss",
    DATE_LONG_12H: "YYYY-MM-DD hh:mm:ss A",
    DATE_LONG_12H_SHORT_HOUR: "YYYY-MM-DD hh:mm A",
    DATE_LONG_SHORT_HOUR: "YYYY-MM-DD HH:mm",
    HOUR: "HH:mm:ss",
    HOUR_LOWER: "hh:mm:ss",
    HOUR_MINIMAL: "HH:mm",
    ONLY_HOUR: "HH",
    ONLY_MINUTE: "mm",
    ONLY_SECONS: "ss",
    HOUR_12H: "hh:mm:ss A",
    HOUR_12H_MINIMAL: "hh:mm A",
    DAY_NAME: "ddd",
    DAY_NUMBER: "DD",
    DAY_AND_MONTH_NAME: "DD MMM",
    CUSTOM_1_es: "D [de] MMMM [de] YYYY ● hh:mm A",
    CUSTOM_1_en: "MMMM D, YYYY ● HH:mm A",
};

class DateUtils {
    constructor() {
    }

  static parse({ date, timezone = DEFAULT_TIME_ZONE }) {
    if (!date) {
      throw new Error('DATE IS UNDEFINED');
    }
    return moment.tz(date, timezone);
  }

    static parseHour({date, timezone = DEFAULT_TIME_ZONE}) {
        if (!date) {
            throw Error("DateUtils.parseHour: date is null");
        }
        return moment(date, FORMATS.HOUR);
    }

    static parseForced({date, format = FORMATS.DATE_LONG}) {
        return moment(date).format(format);
    }

    static parseFormat({
                           date = null,
                           timezone = DEFAULT_TIME_ZONE,
                           lang = "es",
                           format,
                       }) {
        return this.parse({date, timezone})
            .locale(lang)
            .format(format);
    }

    static toHourString({date, timezone, format = FORMATS.HOUR}) {
        return this.parseFormat({date, timezone, format});
    }

    static toHour12String({date, timezone, format = FORMATS.HOUR_12H}) {
        return this.parseFormat({date, timezone, format});
    }

    static toHour12MinimalString({
                                     date,
                                     timezone,
                                     format = FORMATS.HOUR_12H_MINIMAL,
                                 }) {
        return this.parseFormat({date, timezone, format});
    }

    static toDateString({date, timezone, format = FORMATS.DATE_LONG}) {
        return this.parseFormat({date, timezone, format});
    }

    static toDate12HString({date, timezone, format = FORMATS.DATE_LONG_12H}) {
        return this.parseFormat({date, timezone, format});
    }

    static toDate12HShortHourString({
                                        date,
                                        timezone,
                                        format = FORMATS.DATE_LONG_12H_SHORT_HOUR,
                                    }) {
        return this.parseFormat({date, timezone, format});
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    static toDateShortString({date, timezone, format = FORMATS.DATE_SHORT}) {
        return this.parseFormat({date, timezone, format});
    }
    static plusDayToDateShortString({date, timezone, format = FORMATS.DATE_SHORT}){


    var dateNew = new Date(date);
    console.log(dateNew , typeof dateNew)

    return this.parseFormat({date, timezone, format});
    }

    static addDays({date = null, amount, timezone = DEFAULT_TIME_ZONE}) {
        if (!date) {
            throw new Error(`date=${date} no es una fecha válida.`);
        }
        const tempDate = this.parse({date, timezone});
        tempDate.add(amount, "days");
        return tempDate;
    }

    static subtractDays({date = null, amount, timezone = DEFAULT_TIME_ZONE}) {
        if (!date) {
            throw new Error(`date=${date} no es una fecha válida.`);
        }
        const tempDate = this.parse({date, timezone});
        tempDate.subtract(amount, "days");
        return tempDate;
    }

    static isBefore({before, date, by = "day", timezone = DEFAULT_TIME_ZONE}) {
        before = this.parse({date: before, timezone});
        date = this.parse({date: date, timezone});
        return before.isBefore(date, by);
    }
    static isValid(date) {
        const currentDate = new Date();
        const dateEntered = new Date(date);
        return dateEntered.getTime() <= currentDate.getTime();
    }

    static isSame({same, date, timezone = DEFAULT_TIME_ZONE}) {
        same = this.parse({date: same, timezone});
        date = this.parse({date, timezone});
        const v = same.isSame(date, "day");
        return v;
    }

    static startDate({date, timezone = DEFAULT_TIME_ZONE}) {
        return this.parse({date, timezone}).startOf("day");
    }

    static startMonth({date, timezone = DEFAULT_TIME_ZONE}) {
        return this.parse({date, timezone}).startOf("month");
    }

    static getShortDay({date, timezone, lang = "es"}) {
        return this.parseFormat({date, timezone, lang, format: FORMATS.DAY_NAME});
    }

    static getDayNumber({date, timezone, lang = "es"}) {
        return this.parseFormat({
            date,
            timezone,
            lang,
            format: FORMATS.DAY_NUMBER,
        });
    }

    static getDateShort({date, timezone, lang = "es"}) {
        return this.parseFormat({
            date,
            timezone,
            lang,
            format: FORMATS.DAY_AND_MONTH_NAME,
        });
    }

    static toISOString({date, timezone}) {
        return this.parse({date, timezone}).toISOString();
    }

    static getTime({time}) {
        time = moment(time, FORMATS.HOUR);
        const hours = time.toObject().hours;
        const minutes = time.toObject().minutes;
        const seconds = time.toObject().seconds;
        const timeInMinutes = hours * 60 + minutes + seconds / 60;
        return timeInMinutes;
    }

    /**
     *
     * @param initialDate
     * @param finalDate
     * @returns {number}
     */
    static differenceInDays(initialDate,finalDate){
        var initial = new Date(initialDate);
        var final = new Date(finalDate);
        var difference = final -initial;
        return difference/(1000 * 60 * 60 * 24);
    }
    static timeBetween({time, beforeTime, afterTime, timezone}) {
        const parseTime = ({date}) => {
            return moment(date, FORMATS.HOUR_LOWER);
        };
        time = parseTime({date: time});
        beforeTime = parseTime({date: beforeTime});
        afterTime = parseTime({date: afterTime});
        const v = time.isBetween(beforeTime, afterTime, null, "[]");
        return v;
    }

    static endDate({date, timezone = DEFAULT_TIME_ZONE}) {
        return this.parse({date, timezone}).endOf("day");
    }

    static endMonth({date, timezone = DEFAULT_TIME_ZONE}) {
        return this.parse({date, timezone}).endOf("month");
    }

    static getDayWeek({date, timezone = DEFAULT_TIME_ZONE}) {
        const tempDate = this.parse({date, timezone});
        return tempDate.day();
    }

    static setDay({date, day, timezone}) {
        return this.parse({date, timezone}).set("date", day);
    }

    static addMinutes({date, amount, timezone}) {
        return this.parse({date, timezone}).add(amount, "m");
    }

    static getRanges({
                         minDate = null,
                         maxDate,
                         timezone = DEFAULT_TIME_ZONE,
                         rangeDays = 0,
                         minLimit,
                     }) {
        if (!minDate) {
            throw new Error("minDate es inválido");
        }
        minDate = this.parse({date: minDate, timezone});
        if (rangeDays > 0 || rangeDays < 0) {
            if (rangeDays > 0) {
                minDate = this.addDays({date: minDate, amount: rangeDays, timezone});
                maxDate = this.addDays({
                    date: minDate.toDate(),
                    amount: rangeDays,
                    timezone,
                });
            } else {
                maxDate = minDate;
                minDate = this.subtractDays({
                    date: minDate,
                    amount: rangeDays * -1,
                    timezone,
                });
            }
        }
        const v =
            minLimit &&
            (this.isBefore({before: minDate, date: minLimit, timezone}) ||
                this.isSame({same: minDate, date: minLimit, timezone}));
        if (v) {
            rangeDays = rangeDays > 0 ? rangeDays : rangeDays * -1;
            minDate = this.parse({date: minLimit, timezone});
            maxDate = this.addDays({
                date: minDate.toDate(),
                amount: rangeDays,
                timezone,
            });
            return {
                minDate: minDate.toDate(),
                maxDate: maxDate.toDate(),
            };
        }
        return {minDate: minDate.toDate(), maxDate: maxDate.toDate()};
    }
}

export default DateUtils;
